export default __webpack_public_path__ + "static/heedCapitalLogo_white-07a6797933d6f9b7e4ce8b773d8d20fc.svg";